import { createAuth0 } from '@auth0/auth0-vue';
import { defineNuxtPlugin, useRuntimeConfig } from '#imports';
import { AUTH } from '@/constants/common';

export default defineNuxtPlugin((nuxtApp) => {
  const publicConfig = useRuntimeConfig().public;
  // 個人環境の場合はそのhostにリダイレクトする
  const url = new URL(location.href);
  const appUrl = url.host.includes('personal') ? url.origin : `${publicConfig.appUrl}`;
  nuxtApp.vueApp.use(
    createAuth0(
      {
        domain: publicConfig.auth0Domain,
        clientId: publicConfig.auth0ClientId,
        /**
         * @type 'localstorage' | 'memory'
         * The possible locations where tokens can be stored.
         */
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
        authorizationParams: {
          redirect_uri: `${appUrl}${AUTH.REDIRECT.CALLBACK}`,
          audience: publicConfig.auth0Audience,
        },
      },
      {
        // SDK はコールバック処理に失敗すると既定で '/' へ遷移する。'/' はミドルウェアが
        // 再ログインへ送るため、Auth0 が恒久的に拒否する状態ではループになる (SC-2097)。
        errorPath: AUTH.REDIRECT.AUTH_ERROR,
      },
    ),
  );
});
